import { useEffect, useState } from "react";
import { ArrowUpOutlined } from "@ant-design/icons";
import { useTranslation } from "../../i18n";
import "./BackToTop.css";

const SHOW_AFTER_PX = 480;

function getScrollTop() {
    if (typeof window === "undefined") return 0;
    return (
        window.scrollY ||
        document.scrollingElement?.scrollTop ||
        document.documentElement.scrollTop ||
        0
    );
}

function BackToTop() {
    const { t } = useTranslation();
    const [visible, setVisible] = useState(false);
    const label = t("common.scrollToTop");

    useEffect(() => {
        const handleScroll = () => {
            setVisible(getScrollTop() > SHOW_AFTER_PX);
        };

        handleScroll();
        window.addEventListener("scroll", handleScroll, { passive: true });
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    const handleClick = () => {
        try {
            window.scrollTo({ top: 0, behavior: "smooth" });
        } catch {
            window.scrollTo(0, 0);
        }
    };

    return (
        <button
            type="button"
            className={`back-to-top${visible ? " back-to-top--visible" : ""}`}
            onClick={handleClick}
            aria-label={label}
            title={label}
        >
            <ArrowUpOutlined aria-hidden="true" />
        </button>
    );
}

export default BackToTop;
